import usePleaseWait from '../../hooks/usePleaseWait';

type ThanksProps = {
  reservation: any;
}

const Thanks = ({ reservation }: ThanksProps) => {
  const { pleasWaitPopup }: any = usePleaseWait();
  

  return (
    <div className="w-full h-full px-4 md:px-8 py-8">
      {!pleasWaitPopup && (
        <div className="flex flex-col md:flex-row gap-6">

          {/* Thank You Message */}
          <div className="w-full">
            <div className="bg-green-50 border border-green-300 text-green-900 text-sm rounded-lg p-4 mb-6 text-center shadow">
              🎉 Thank you for your reservation!
              <div className="mt-1 text-base font-semibold text-green-800">
                Booking # <span className="ml-1">{reservation?.bookingNumber}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Thanks